<template>
	<div class="v5-scroller" :id="containerId" @touchstart="touchStart($event)" @touchmove="touchMove($event)" @touchend="touchEnd($event)">
		<slot></slot>
	</div>
</template>
<script>
import Scroller from './Scroller';
import render from './render';

export default {
	name: 'v5-scroller',
	props: {
		autoResize: {
			type: Boolean,
			default: true
		},
		positionX: {
			type: Number,
			default: 0
		},
		positionY: {
			type: Number,
			default: 0
		},
		scrollingX: {
			type: Boolean,
			default: false
		},
		scrollingY: {
			type: Boolean,
			default: true
		},
		animating: {
			type: Boolean,
			default: true
		},
		animationDuration: {
			type: Number,
			default: 250
		},
		bouncing: {
			type: Boolean,
			default: true
		},
		locking: {
			type: Boolean,
			default: true
		},
		paging: {
			type: Boolean,
			default: false
		},
		snapping: {
			type: Boolean,
			default: false
		},
		size: {
			type: Number,
			default: 100
		},
		zooming: {
			type: Boolean,
			default: false
		},
		minZoom: {
			type: Number,
			default: 0.5
		},
		maxZoom: {
			type: Number,
			default: 3
		}
	},
	watch: {
		positionX(val) {
			this.scroller.scrollTo(val, this.positionY);
		},
		positionY(val) {
			this.scroller.scrollTo(this.positionX, val);
		}
	},
	methods: {
		init() {
			if (this.isInstall) return;
			this.isInstall = true;

			//设置位置
			let rect = this.container.getBoundingClientRect();
			this.scroller.setPosition(
				rect.left + this.container.clientLeft,
				rect.top + this.container.clientTop
			);

			//设置size
			this.resize();

			//设置初始位置
			if (this.positionX || this.positionY) {
				this.scroller.scrollTo(this.positionX, this.positionY);
			}

			//设置snapping
			if (this.snapping) {
				this.scroller.setSnapSize(
					this.contentW / this.size,
					this.contentH / this.size
				);
			}
		},
		//设置容器大小
		resize() {
			this.contentW = this.content.offsetWidth;
			this.contentH = this.content.offsetHeight;
			this.scroller.setDimensions(
				this.container.clientWidth,
				this.container.clientHeight,
				this.contentW,
				this.contentH
			);
		},
		touchStart(e) {
			// 如果在表单元素上发生初始化，则不要做出反应
			if (e.target.tagName.match(/input|textarea|select/i)) {
				return;
			}
			this.scroller.doTouchStart(e.touches, e.timeStamp);
			this.$emit('on-touchstart', e);
		},
		touchMove(e) {
			e.preventDefault();
			this.scroller.doTouchMove(e.touches, e.timeStamp);
			this.$emit('on-touchmove', e);
		},
		touchEnd(e) {
			this.scroller.doTouchEnd(e.timeStamp);
			this.$emit('on-touchend', e);
		},
		scrollEnd() {
			let position = this.scroller.getValues();
			this.$emit('on-scrollend', position);
		}
	},
	updated() {
		this.$nextTick(() => {
			this.init();
			if (this.autoResize) {
				this.resize();
			}
		});
	},
	mounted() {
		this.container = document.getElementById(this.containerId);
		this.content = this.container.firstChild;
		this.$nextTick(() => {
			this.scroller = new Scroller(render(this.content), {
				scrollingX: this.scrollingX,
				scrollingY: this.scrollingY,
				animating: this.animating,
				animationDuration: this.animationDuration,
				bouncing: this.bouncing,
				locking: this.locking,
				paging: this.paging,
				snapping: this.snapping,
				zooming: this.zooming,
				minZoom: this.minZoom,
				maxZoom: this.maxZoom,
				scrollingComplete: this.scrollEnd
			});
			this.contentW = this.content.offsetWidth;
			this.contentH = this.content.offsetHeight;

			//初始化
			if (this.contentW || this.contentH) {
				this.init();
			}
		});
	},
	data() {
		return {
			containerId:
				'scroller-' +
				Math.random()
					.toString(36)
					.substring(3, 10),
			container: undefined,
			content: undefined,
			contentW: 0,
			contentH: 0,
			isInstall: false,
			scroller: undefined
		};
	}
};
</script>
<style lang="scss">
@import './style.scss';
</style>



// WEBPACK FOOTER //
// index.vue?5ba3e0b8